<template>
  <div :class="(navbar?'nossos-servicos-vertical':'')">
    <div v-if="!navbar" id="textoServico"><h1 class="textoNossosServicos  ml-4">Nossos <strong>Serviços</strong></h1></div>
    <div class="nossos-servicos-resolve">
      <div class="card-banner-resolve">
        <img class="banner-resolve" src="@/assets/imgs/nossos_servicos/banner-resolve.png" />
        <img class="logo-resolve" src="@/assets/imgs/nossos_servicos/logo-resolve.png" />
      </div>
      <img class="logo-resolve-mobile" src="@/assets/imgs/nossos_servicos/logo-resolve.png" />
      <div class="resolve-servico">
        <h2>Resolve</h2>
        <span>Negocie dívidas em seu CPF sem intermediários, cancele protestos em poucos minutos e receba comunicação 100% digital sobre pendências e soluções.</span>
        <button class="btn-primary" @click="abreResolve">Negociar Agora</button>
      </div>
    </div>

    <hr class="my-divider">

    <div class="nossos-servicos-resolve ibama-container" style="margin-top: 180px;">
      <div class="card-banner-resolve">
        <img class="banner-resolve ibama-img-desk" src="@/assets/imgs/nossos_servicos/logo-ibama.svg" />
      </div>

      <img class="logo-resolve-mobile ibama-img-mobile" src="@/assets/imgs/nossos_servicos/img_ibama_celular.jpg" />
      
      <div class="resolve-servico">
        <h2>Consulta de CPF / CNPJ IBAMA</h2>
        <span>Consulta a protesto de multas ambientais do IBAMA, rápido e 100% on-line!.</span>
        <button class="btn-primary" onclick="window.location.href='/servico/consulta-documento-ibama'">Clique para Consultar</button>
      </div>
    </div>
    <div class="carousel-full-width-container">
      <div class="carousel-viewport">
        <div
            class="cards-servicos-carousel"
            ref="carouselContainer"
            @mousedown="onUserInteraction"
            @mousemove="onUserInteraction"
            @mouseup="onUserInteraction"
            @mouseleave="onUserInteraction"
            @touchstart="onUserInteraction"
            @touchmove="onUserInteraction"
            @touchend="onUserInteraction"
            @scroll="onUserInteraction"
        >
          <div class="card-servico" @click="$router.push({name:'servico',params:{servico:'envio-de-titulo'}})">
            <div class="icone-container">
              <img class="icone-card-servico" src="@/assets/imgs/nossos_servicos/icone-servico-protesto.png" />
            </div>
            <h3>Protesto</h3>
            <span>Solucione dívidas e protestos em um só lugar.</span>
          </div>
          <div class="card-servico" @click="$router.push({name:'servico',params:{servico:'pedido-anuencia'}})">
            <div class="icone-container">
              <img class="icone-card-servico" src="@/assets/imgs/nossos_servicos/icone-servico-cancelamento.png" />
            </div>
            <h3>Cancelamento</h3>
            <span>Autorização de Cancelamento (Carta de anuência eletrônica)</span>
          </div>
          <div class="card-servico" @click="$router.push({name:'servico',params:{servico:'consulta-edital'}})">
            <div class="icone-container">
              <img class="icone-card-servico" src="@/assets/imgs/nossos_servicos/icone-servico-edital.png" />
            </div>
            <h3>Edital Eletrônico</h3>
            <span>Consulta e emissão de edital eletrônico atualizado</span>
          </div>
          <div class="card-servico" @click="$router.push({name:'servico',params:{servico:'pedido-certidao'}})">
            <div class="icone-container">
              <img class="icone-card-servico" src="@/assets/imgs/nossos_servicos/icone-servico-certidao.png" />
            </div>
            <h3>Certidão</h3>
            <span>Pedido de certidão e verificação de autenticidade</span>
          </div>
          <div class="card-servico" @click="$router.push({name:'servico',params:{servico:'renegociacao-dividas-protestadas'}})">
            <div class="icone-container">
              <img class="icone-card-servico" src="@/assets/imgs/nossos_servicos/icone-servico-renegociacao.png" />
            </div>
            <h3>Renegociação</h3>
            <span>Renegocie dívidas protestadas diretamente pelo sistema.</span>
          </div>
        </div>
      </div>
      <div class="carousel-bullets">
        <button
            class="carousel-bullet"
            :class="{ active: activeSnap === 'start' }"
            @click="onBulletClick('start')"
        ></button>
        <button
            class="carousel-bullet"
            :class="{ active: activeSnap === 'end' }"
            @click="onBulletClick('end')"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
// import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
// import 'swiper/swiper-bundle.css';

// Swiper.use([Navigation, Pagination, Autoplay]);



export default {
  props: {
    navbar: Boolean,
    logged: Boolean,
  },
  data(){
    return {
      titulosSubmenu: false,
      anuenciaSubmenu: false,
      certidaoSubmenu: false,
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
      activeSnap: 'start',
      idleTimer: null,
      isIdleMode: false,
      idleAnimationFrame: null,
      idleStartTime: null,
      idlePhase: 'initial', // 'initial', 'scrolling', 'waiting', 'returning'
      isMobile: false

    }
  },
  mounted() {
    this.updateActiveSnap();
    this.checkMobile();
    this.startIdleTimer();
    if (this.$refs.carouselContainer) {
      this.$refs.carouselContainer.addEventListener('scroll', this.updateActiveSnap);
    }
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    if (this.$refs.carouselContainer) {
      this.$refs.carouselContainer.removeEventListener('scroll', this.updateActiveSnap);
    }

    window.removeEventListener('resize', this.checkMobile);
    this.clearIdleTimer();
    this.stopIdleMode();
  },
  methods: {
    abreResolve(){
      window.open("https://resolve.cenprot.org.br/", "_blank");
    },
    servico(tab){
      this.$root.$emit('servicoclicado',tab)
      this.$emit('servicoclicado',tab)
    },
    toggleSubMenu(menu){
      switch (menu) {
        case 'titulo':
          this.titulosSubmenu = !this.titulosSubmenu;
          this.anuenciaSubmenu = false;
          this.certidaoSubmenu = false;
          break;
        case 'anuencia':
          this.anuenciaSubmenu = !this.anuenciaSubmenu;
          this.titulosSubmenu = false;
          this.certidaoSubmenu = false;
          break;
        case 'certidao':
          this.certidaoSubmenu = !this.certidaoSubmenu;
          this.titulosSubmenu = false;
          this.anuenciaSubmenu = false;
          break;
      }
    },
    startDrag(e) {
      this.isDragging = true;
      this.startX = e.pageX || e.touches[0].pageX;
      this.scrollLeft = this.$refs.carouselContainer.scrollLeft;
      this.$refs.carouselContainer.style.cursor = 'grabbing';
    },
    onDrag(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const x = e.pageX || e.touches[0].pageX;
      const walk = (x - this.startX) * 2;
      this.$refs.carouselContainer.scrollLeft = this.scrollLeft - walk;
    },
    stopDrag() {
      this.isDragging = false;
      this.$refs.carouselContainer.style.cursor = 'grab';
    },
    snapToStart() {
      const parentContainer = document.getElementById('nossos-servicos');
      const parentRect = parentContainer.getBoundingClientRect();
      const carouselRect = this.$refs.carouselContainer.getBoundingClientRect();
      const container = this.$refs.carouselContainer;

      const firstCard = container.querySelector('.card-servico:first-child');
      const firstCardRect = firstCard.getBoundingClientRect();

      const containerStyles = window.getComputedStyle(container);
      const paddingLeft = parseFloat(containerStyles.paddingLeft);

      const targetScrollLeft = this.$refs.carouselContainer.scrollLeft + (firstCardRect.left - parentRect.left - paddingLeft);

      this.$refs.carouselContainer.scrollTo({
        left: targetScrollLeft,
        behavior: 'smooth'
      });
      this.activeSnap = 'start';
    },
    snapToEnd() {
      const parentContainer = document.getElementById('nossos-servicos');
      const parentRect = parentContainer.getBoundingClientRect();
      const carouselRect = this.$refs.carouselContainer.getBoundingClientRect();
      const container = this.$refs.carouselContainer;

      const lastCard = container.querySelector('.card-servico:last-child');
      const lastCardRect = lastCard.getBoundingClientRect();

      const containerStyles = window.getComputedStyle(container);
      const paddingLeft = parseFloat(containerStyles.paddingLeft);

      const targetScrollLeft = this.$refs.carouselContainer.scrollLeft + (lastCardRect.right - parentRect.right + paddingLeft);

      container.scrollTo({
        left: targetScrollLeft,
        behavior: 'smooth'
      });
      this.activeSnap = 'end';
    },
    updateActiveSnap() {
      const container = this.$refs.carouselContainer;
      const allCards = container.querySelectorAll('.card-servico');
      const totalCards = allCards.length;

      const scrollLeft = container.scrollLeft;
      const maxScroll = container.scrollWidth - container.clientWidth;
      const scrollProgress = scrollLeft / maxScroll;

      if (scrollProgress <= 0.5) {
        this.activeSnap = 'start';
      } else {
        this.activeSnap = 'end';
      }
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    startIdleTimer() {
      this.clearIdleTimer();
      this.idleTimer = setTimeout(() => {
        this.startIdleMode();
      }, 10000);
    },
    clearIdleTimer() {
      if (this.idleTimer) {
        clearTimeout(this.idleTimer);
        this.idleTimer = null;
      }
    },
    onUserInteraction() {
      if (this.isIdleMode && event && event.type === 'scroll') {
        return;
      }

      this.stopIdleMode();
      this.startIdleTimer();
      if (event.type === 'mousedown' || event.type === 'touchstart') {
        this.startDrag(event);
      } else if (event.type === 'mousemove' || event.type === 'touchmove') {
        this.onDrag(event);
      } else if (event.type === 'mouseup' || event.type === 'touchend' || event.type === 'mouseleave') {
        this.stopDrag();
      }
    },
    onBulletClick(position) {
      this.onUserInteraction();
      if (position === 'start') {
        this.snapToStart();
      } else {
        this.snapToEnd();
      }
    },
    startIdleMode() {
      console.log("idle");
      if (this.isIdleMode) return;

      this.isIdleMode = true;
      this.idlePhase = 'initial';
      this.idleStartTime = Date.now();

      if (this.isMobile) {
        this.startMobileIdleAnimation();
      } else {
        this.startDesktopIdleAnimation();
      }
    },
    stopIdleMode() {
      this.isIdleMode = false;
      this.idlePhase = 'initial';

      if (this.idleAnimationFrame) {
        cancelAnimationFrame(this.idleAnimationFrame);
        this.idleAnimationFrame = null;
      }
    },

    startMobileIdleAnimation() {
      console.log("idle mobile");
      this.snapToStart();

      setTimeout(() => {
        if (!this.isIdleMode) return;
        this.idlePhase = 'scrolling';
        this.performMobileSlowScroll();
      }, 1000);
    },
    performMobileSlowScroll() {
      if (!this.isIdleMode || this.idlePhase !== 'scrolling') return;

      const container = this.$refs.carouselContainer;
      const maxScroll = container.scrollWidth - container.clientWidth;
      const scrollSpeed = 10;
      let lastTime = 0;
      const delay = 50;
      const animate = (currentTime) => {
        if (!this.isIdleMode || this.idlePhase !== 'scrolling') return;
        if (currentTime - lastTime >= delay) {
          const currentScroll = container.scrollLeft;
          const newScrollPosition = currentScroll + scrollSpeed;
          if (newScrollPosition >= maxScroll) {
            container.scrollLeft = maxScroll;
            this.idlePhase = 'waiting';
            setTimeout(() => {
              if (!this.isIdleMode) return;
              this.idlePhase = 'returning';
              this.performMobileSlowScrollBack();
            }, 2000);
            return;
          }
          container.scrollLeft = newScrollPosition;
          lastTime = currentTime;
        }
        this.idleAnimationFrame = requestAnimationFrame(animate);
      };
      this.idleAnimationFrame = requestAnimationFrame(animate);
    },
    performMobileSlowScrollBack() {
      if (!this.isIdleMode || this.idlePhase !== 'returning') return;

      const container = this.$refs.carouselContainer;
      const scrollSpeed = 10;

      const animate = () => {
        if (!this.isIdleMode || this.idlePhase !== 'returning') return;

        const currentScroll = container.scrollLeft;
        const newScrollPosition = currentScroll - scrollSpeed;

        if (newScrollPosition <= 0) {
          container.scrollLeft = 0;
          this.idlePhase = 'waiting';
          setTimeout(() => {
            if (!this.isIdleMode) return;
            this.startMobileIdleAnimation();
          }, 2000);
          return;
        }
        container.scrollLeft = newScrollPosition;
        this.idleAnimationFrame = requestAnimationFrame(animate);
      };
      this.idleAnimationFrame = requestAnimationFrame(animate);
    },
    startDesktopIdleAnimation() {
      console.log("start idle mode");
      this.idlePhase = 'scrolling';
      this.performDesktopIdleCycle();
    },
    performDesktopIdleCycle() {
      if (!this.isIdleMode) return;
      this.snapToStart();
      setTimeout(() => {
        if (!this.isIdleMode) return;
        this.snapToEnd();
        setTimeout(() => {
          if (!this.isIdleMode) return;
          this.performDesktopIdleCycle();
        }, 3000);
      }, 3000);
    }
  }
}
</script>

<style scoped>

.swiper-container {
    width: 80%; /* Ajuste para 80% da largura do elemento pai */
    max-width: 1250px; /* Defina um limite máximo de largura */
    height: 300px; /* Ajuste automático para altura */
    margin: 0 auto; /* Centralize o carrossel */
    padding: 20px; /* Adicione um espaçamento interno */
    box-sizing: border-box; /* Inclua padding no cálculo do tamanho */
}
.swiper-slide:first-child {
    margin-left: 40px; /* Espaço apenas no primeiro card */
}
.swiper-pagination {
    margin-top: 20px; /* Adicione a margem superior */
    text-align: center; /* Garanta que fique centralizado */
}




#textoServico{margin-top: calc(8%);}
.imgNossoServicos{margin-top: calc(40%);}
.tituloCardServicos{color: #69A9Fc;font-weight: bold;font-size: 16;}
.textoCardServicos{color: #084F84;font-size: 14px;}
.textoNossosServicos{color: #084f84;font-size: 29px;line-height: 25px;text-align: left;font-weight: bold;}
.nossos-servicos-home-card-header.bg-FFFFFF{border:3px solid; color: #1ACEB5; background-color: #1ACEB5;}
.card-header-logo-resolve{height:28px;width:auto;}
.card-resolve .nossos-servicos-home-card-bod-row a{height: fit-content !important;padding: 5px 24px;}
@media (min-width: 900px) {
  .textoNossosServicos{color: #084f84;font-size: 35px;padding:2px;text-align: left;}
}
.nossos-servicos-vertical{margin: 0 !important;box-shadow: 0px 0px 9px 0px #00000040;}
.nossos-servicos-vertical .nossos-servicos-home-row {flex-flow: column;width: 100%;}
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card{width: 100%;margin: 0 !important;}
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-header{border-radius:0;}

.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body{background-color:white;height: fit-content;padding: 0;}

.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile{cursor: pointer;}


.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(1) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile:hover .nossos-servicos-subitem a,
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(1) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile.active .nossos-servicos-subitem a,
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(1) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row:hover a{background-color:#4BA56D;color:white;}

.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(2) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile:hover .nossos-servicos-subitem a,
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(2) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile.active .nossos-servicos-subitem a,
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(2) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row:hover a{background-color:#4780F1;color:white;}


.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(3) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile:hover .nossos-servicos-subitem a,
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(3) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile.active .nossos-servicos-subitem a,
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(3) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row:hover a{background-color:#3791E7;color:white;}


.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(4) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile:hover .nossos-servicos-subitem a,
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(4) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile.active .nossos-servicos-subitem a,
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(4) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row:hover a{background-color:#16B0D2;color:white;}


.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(5) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile:hover .nossos-servicos-subitem a,
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(5) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile.active .nossos-servicos-subitem a,
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(5) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row:hover a{background-color:#1ACEB5;color:white;}

.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row:after{margin: 0;width: 100%;}
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(3) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row .nossos-servicos-item,
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(3) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row a{height: 60px;}

.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile .nossos-servicos-subitem a{
  color:#ffffff;
  display: flex;
  flex-flow: column;
  height: 41px;
  line-height: 40px;
  padding: 0;
}
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile .nossos-servicos-subitem a:not(:last-child):after{
  content:'';
  width: 201px;
  height: 1px;
  background-color: #ffffff;

}
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile .nossos-servicos-subitem{
  /* display: none; */
  height:0px;
  overflow:hidden;
  opacity: 0;
  /* position: absolute; */
  flex-flow: column;
  width: 300px;
  /* margin-top: 41px; */
  box-shadow: 0px 3px 6px #00000029;
}
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(2) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile .nossos-servicos-subitem{
  /* margin-top: 60px; */
}
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile.active .nossos-servicos-subitem,
.nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile:hover .nossos-servicos-subitem{display:flex;opacity: 1;height:fit-content;transition: height 1.3s ease-in;}

.nossos-servicos-resolve{
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  margin-bottom: 150px;
}
.nossos-servicos-resolve .card-banner-resolve{
  display: flex;
  width: 712px;
  height: 351px;
  border-radius: 50px;
  box-shadow: 4px 4px 50px 0 #D1DBE2;
  justify-content: space-between;
  align-items: center;
  padding: 0 0px 16px 22px;
}
.nossos-servicos-resolve .card-banner-resolve img.banner-resolve{
  align-self: end;
}
.nossos-servicos-resolve .card-banner-resolve img.logo-resolve{
  width: 173px;
  height: 43px;
  margin:0 auto;
}
.nossos-servicos-resolve img.logo-resolve-mobile{
  display: none;
}

.nossos-servicos-resolve .resolve-servico{
  display: flex;
  flex-flow: column;
  height: 351px;
  width: 447px;
  justify-content: center;
  margin-right: 108px;
  margin-left: auto;
}
.nossos-servicos-resolve .resolve-servico h2{
  font-family: 'Kanit', sans-serif;
  font-size: 42px;
  line-height: 77px;
  font-weight: 200;
  letter-spacing: -1%;
  color: var(--secondary-color);
  text-transform: none;
}
.nossos-servicos-resolve .resolve-servico span{
  font-family: 'Kanit', sans-serif;
  font-size: 16px;
  line-height: 27px;
  font-weight: 300;
  letter-spacing: -1%;
  color: var(--secondary-color);
  text-transform: none;
  margin-bottom: 63px;
}
.nossos-servicos-resolve .resolve-servico .btn-primary{
  width:272px;
  height: 49px;
}

.carousel-full-width-container {
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  width: 100vw;
}

.carousel-viewport {
  width: 100%;
  position: relative;
}

.carousel-viewport::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: calc((100vw - 1387px) / 2);
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.cards-servicos-carousel {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  gap: 39px;
  padding: 0 calc((100vw - 1387px) / 2);
  cursor: grab;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.cards-servicos-carousel::-webkit-scrollbar {
  display: none;
}

.cards-servicos-carousel .card-servico {
  display: flex;
  cursor: pointer;
  flex-flow: column;
  box-shadow: 4px 4px 50px 0 #D1DBE2;
  background: #FFFFFF;
  border-radius: 20px;
  padding: 10px 52px 40px 52px;
  width: 319px;
  height: 279px;
  justify-content: end;
  flex-shrink: 0;
  user-select: none;
  margin-top:56px;
  margin-bottom:56px;
}

.cards-servicos-carousel .card-servico .icone-container {
  display: flex;
  width: 100%;
  height: 156px;
  align-items: center;
  justify-content: center;
}

.cards-servicos-carousel .card-servico:nth-child(1) .icone-container img.icone-card-servico {
  width: 81px;
  height: 81px;
}
.cards-servicos-carousel .card-servico:nth-child(2) .icone-container img.icone-card-servico {
  width: 92px;
  height: 73px;
}
.cards-servicos-carousel .card-servico:nth-child(3) .icone-container img.icone-card-servico {
  width: 126px;
  height: 67px;
}
.cards-servicos-carousel .card-servico:nth-child(4) .icone-container img.icone-card-servico {
  width: 94px;
  height: 92px;
}

.cards-servicos-carousel .card-servico h3 {
  font-family: 'Kanit', sans-serif;
  font-size: 24px;
  line-height: 37px;
  font-weight: 500;
  letter-spacing: -1%;
  color: var(--primary-color);
  text-transform: none;
}

.cards-servicos-carousel .card-servico span {
  font-family: 'Kanit', sans-serif;
  font-size: 16px;
  line-height: 23px;
  font-weight: 300;
  letter-spacing: -1%;
  color: var(--secondary-color);
  text-transform: none;
  width: 214px;
}

.carousel-bullets {
  display: flex;
  justify-content: center;
  gap: 16px;
  position: relative;
  z-index: 2;
}

.carousel-bullet {
  width: 19px;
  height: 19px;
  border-radius: 50%;
  border: none;
  background-color: #D9D9D9;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.carousel-bullet:hover {
  background-color: #bbb;
}

.carousel-bullet.active {
  background-color: #5CB3FF;
  cursor: default;
}

.cards-servicos {
  display: none;
}

@media (max-width: 1387px) {
  .cards-servicos-carousel {
    padding: 0 20px;
  }

  .carousel-viewport::before {
    width: 20px;
  }
}

@media (max-width:1300px){
  .nossos-servicos-home-row{flex-flow: column;max-width:calc(335px + 34px);margin:0 auto;}
  .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card{min-width: 300px;}
  .nossos-servicos-home-row .nossos-servicos-home-card{margin: 0;width: 100%;min-width: 335px;box-shadow:0px 3px 6px #00000029;}
  .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-header{border-radius: 0;}
  .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body{padding: 0;background-color: white;height: fit-content;}
  .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row:after{margin: 0;width: 100%;}
  .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row .nossos-servicos-item:after {content: '';border-bottom: 3px solid #597EB5;border-right: 3px solid #597EB5;transform: rotate(45deg);width: 8px;height: 8px;position: absolute;right:46px;}
  .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile .nossos-servicos-subitem{width:100%;}
  .nossos-servicos-vertical{width:100%;}
}
@media (max-width:420px) {
  .nossos-servicos-home-row{padding:0 17px}
  .nossos-servicos-home-row .nossos-servicos-home-card{min-width: unset;}
  .nossos-servicos-vertical .nossos-servicos-home-row{padding:0}
}

@media (max-width:1300px) {
  .exibe-gif-resolve {
    display: none;
  }
  .exibe-card-resolve{
    display: block;
  }
}

/* Para telas grandes */
@media (min-width: 1301px) {
  .exibe-gif-resolve {
    display: block;
  }
  .exibe-card-resolve{
    display: none;
  }
}

@media (max-width:1440px) {
  .nossos-servicos-resolve{justify-content: space-between;gap:50px;}
  .nossos-servicos-resolve .card-banner-resolve{
    width: 622px;
  }
  .nossos-servicos-resolve .resolve-servico{margin:unset;}
}
@media (max-width: 1200px){
  .nossos-servicos-resolve{justify-content: center;gap:30px;flex-flow: column;margin-bottom: 56px;}
  .nossos-servicos-resolve .card-banner-resolve{width: 100%;}
  .nossos-servicos-resolve .resolve-servico {margin: 0 auto;}
}
@media (max-width: 992px){
}
@media (max-width: 768px){
  .nossos-servicos-resolve .card-banner-resolve{
    box-shadow: none;
    padding: 0;
    height: fit-content;
  }
  .nossos-servicos-resolve .card-banner-resolve img.banner-resolve{
    width: 100%;
    height: auto;
  }
  .nossos-servicos-resolve .card-banner-resolve img.logo-resolve{
    display: none;
  }
  .nossos-servicos-resolve img.logo-resolve-mobile{
    display: flex;
    width: 173px;
    height: 43px;
    margin: 30px auto 0px auto;
  }

.ibama-container .card-banner-resolve {
  display: flex;
  justify-content: center; /* Isso traz a imagem para o meio do bloco horizontalmente */
  /* Mantém a imagem alinhada ao topo para preservar o efeito de sobreposição */
  align-items: flex-start; 
}

/* Garante que a imagem respeite o tamanho original e não estique */
.ibama-container .card-banner-resolve img.banner-resolve {
  width: auto; /* Ou defina um width fixo se necessário, ex: 200px */
  max-width: 100%;
}

  .cards-servicos-carousel .card-servico {
    width: 280px;
    padding: 10px 40px 40px 40px;
  }

  .cards-servicos-carousel .card-servico span {
    width: 200px;
  }
}
@media (max-width: 600px){
  .nossos-servicos-resolve .resolve-servico {width: 100%;}

  .cards-servicos-carousel {
    gap: 20px;
    padding: 0 15px;
  }

  .cards-servicos-carousel .card-servico {
    width: 260px;
    padding: 10px 30px 30px 30px;
  }
}

.my-divider {
  /* Estilos personalizados para a sua divisória */
  border: none;
  border-top: 1px solid #3ec8ff;
  margin: 20px 0;
}

.ibama-container .card-banner-resolve {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ibama-container .ibama-img-desk {
  width: 58%;
  margin: 0; 
  align-self: center; 
}

@media (max-width: 768px) {
  
  .ibama-container .ibama-img-desk {
     margin-left: 0; 
     width: 80%;
  }

  .ibama-container img.ibama-img-mobile {
    width: 100%;       
    max-width: 250px;  
    height: auto;      
    margin: 20px auto; 
    display: block;
  }
}
</style>